import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import TopHeader from './TopHeader';
import { StoresProvider } from '../../context/StoresContext';

const DashboardLayout = () => {
  return (
    <StoresProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Sidebar />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TopHeader />
          <Box component="main" sx={{ p: 3 }}>
            <Toolbar />
            <Outlet />
          </Box>
        </Box>
      </Box>
    </StoresProvider>
  );
};

export default DashboardLayout;
